import './App.css'
import { Redirect, Route, Switch } from 'react-router-dom'
import { DOCUMENT_PATH, HOME_PATH, OnlineSigningInfo_PATH, SIGN_IN_PATH } from 'routes/constants.routes'
import PrivateRoute from 'routes/PrivateRoute'
import useAuthStore from 'context/AuthStore/useAuthStore'
import axios from 'axios'
import Home from 'pages/Home/Home'
import NoMatch from 'pages/NoMatch/NoMatch'
import SignIn from 'pages/SignIn/SignIn'
import { useHistory } from 'react-router'
import DocumentPage from 'pages/DocumentPage/DocumentPage'
import { useHomeStore } from './context/HomeStore'
import OnlineSigningInfoPage from './pages/Info/OnlineSigningInfoPage'

function App() {
  const { authStore, authStoreFunc } = useAuthStore()
  const history = useHistory()
  const {
    homeStore: {},
    homeStoreFunc: {}
  } = useHomeStore();


  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.message.includes('401') || [401, 403].includes(error?.request?.status)) {
        localStorage.removeItem('clear')
        authStoreFunc.setLoading(false)
        history.push('/signin')
      } else {
        console.error(error)
      }
      return Promise.reject(error)
    }
  )




  return (
    <Switch>
      <PrivateRoute exact path={HOME_PATH} component={Home} />
      <PrivateRoute exact path={[DOCUMENT_PATH + '/:id']} component={DocumentPage} />
      <Route path={OnlineSigningInfo_PATH} component={OnlineSigningInfoPage} />
      <Route path={SIGN_IN_PATH} render={props => <SignIn {...props} />} />
      <Route path={'/'} render={() => <Redirect to={authStore.isLoggedIn ? HOME_PATH : SIGN_IN_PATH} />} />
      <Route path="*">
        <NoMatch />
      </Route>
    </Switch>
  )
}

export default App
